<div class="h-fit p-5 pt-[8.5rem] lg:pt-52 overflow-auto">
    <div class="py-3 md:mt-10 lg:grid grid-cols-7 text-center lg:w-4/5 mx-auto font-medium lg:space-x-5 space-y-2 md:space-y-0">
        @for (link of links; track link; let i = $index) {
            <app-secondary-button
                    @slideDown [value]="link.text"
                    (click)="setActiveTable(link.route)"></app-secondary-button>
        }
    </div>
    @if (auth.user$ | async; as user) {
        @if (user.email === environment.admin) {
            @switch (activeTable) {
                @case ("reviews") {
                    <app-admin-reviews></app-admin-reviews>
                }
                @case ("orders") {
                    <app-text [value]="'Вкупно нарачки: ' + pageInfo.totalElements"></app-text>

                    <div class="flex flex-wrap gap-3 items-center py-4">
                        <label class="flex items-center gap-2 text-sm">
                            <input type="checkbox"
                                   [checked]="allVisibleEligibleSelected"
                                   [disabled]="visibleEligibleOrders.length === 0 || isBulkCreatingShipments"
                                   (change)="toggleSelectAllEligible($any($event.target).checked)">
                            Избери ги сите што може да се пратат
                        </label>

                        <app-primary-button
                                [value]="isBulkCreatingShipments ? 'Се праќаат…' : 'Креирај Eco пратки'"
                                [disabled]="selectedOrderIds.size === 0 || isBulkCreatingShipments"
                                (click)="createEcoShipments()">
                        </app-primary-button>

                        <span class="text-sm text-neutral-600">Избрани: {{ selectedOrderIds.size }}</span>
                    </div>

                    <ngx-datatable
                            class="shadow-lg rounded-lg p-5 text-sm lg:text-base material"
                            [rows]="orders"
                            [columnMode]="ColumnMode.force"
                            [headerHeight]="50"
                            [footerHeight]="50"
                            [rowHeight]="'auto'"
                            [scrollbarH]="true">

                        <ngx-datatable-column [width]="50" [sortable]="false" [canAutoResize]="false" [draggable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <input type="checkbox"
                                       [checked]="isOrderSelected(row.id)"
                                       [disabled]="!isOrderEligibleForShipment(row) || isBulkCreatingShipments"
                                       (change)="toggleOrderSelection(row, $any($event.target).checked)">
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Пратка" [minWidth]="220" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <div class="flex flex-col gap-1 text-xs lg:text-sm py-1">
                                    <span><strong>Статус:</strong> {{ row.shipmentStatusLabel }}</span>
                                    @if (row.shipment?.trackingNumber) {
                                        <span><strong>Број:</strong> {{ row.shipment?.trackingNumber }}</span>
                                    }
                                    @if (row.shipment?.errorMessage) {
                                        <span class="text-red-600">{{ row.shipment?.errorMessage }}</span>
                                    }
                                    @if (row.shipment?.trackingUrl) {
                                        <div class="flex gap-2">
                                            <button class="text-blue-600 underline" (click)="openTracking(row.shipment?.trackingUrl)">Следи</button>
                                            <button class="text-blue-600 underline" (click)="copyTrackingLink(row.shipment?.trackingUrl)">Копирај линк</button>
                                        </div>
                                    }
                                    @if (shouldShowRetry(row)) {
                                        <button class="text-red-600 underline text-left disabled:text-neutral-400"
                                                [disabled]="retryingOrderIds.has(row.id)"
                                                (click)="retryShipmentForOrder(row)">
                                            {{ retryingOrderIds.has(row.id) ? 'Се праќа…' : 'Прати повторно' }}
                                        </button>
                                    }
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        @for (column of orderColumns; track column.prop) {
                            <ngx-datatable-column
                                    [name]="column.name"
                                    [prop]="column.prop"
                                    [width]="column.width || 120">
                            </ngx-datatable-column>
                        }
                    </ngx-datatable>
                    @if (totalPages !== 0) {
                        <app-pagination
                                [pageNumber]="pageNumber"
                                [totalPages]="totalPages"
                                (pageChange)="onPageChange($event)">
                        </app-pagination>
                    }
                }
                @case ("products") {
                    <div class="lg:flex justify-center lg:justify-between items-center w-full mx-auto lg:mx-0 lg:flex-row-reverse">
                        <app-primary-button
                                class="pt-5 pb-5"
                                [value]="'Додади нов продукт'"
                                (click)="goToUrl(router, '/shop/product/add')">
                        </app-primary-button>
                        <app-text [value]="'Вкупно производи: ' + pageInfo.totalElements"></app-text>
                    </div>
                    <app-table
                            [rows]="products"
                            [columns]="productColumns"
                            (rowClicked)="onProductRowClick($event)"
                    ></app-table>
                    @if (totalPages !== 0) {
                        <app-pagination
                                [pageNumber]="pageNumber"
                                [totalPages]="totalPages"
                                (pageChange)="onPageChange($event)">
                        </app-pagination>
                    }
                }
                @case ("customers") {
                    <div class="lg:flex justify-center lg:justify-between items-center w-full mx-auto lg:mx-0 lg:flex-row-reverse">
                        <app-primary-button
                                class="pt-5 pb-5"
                                [value]="'Прати промотивен емаил'"
                                (click)="goToUrl(router, '/admin-panel/email-marketing')">
                        </app-primary-button>
                        <app-text [value]="'Вкупно потрошувачи: ' + pageInfo.totalElements"></app-text>
                    </div>
                    <app-table [rows]="customers" [columns]="customerColumns"></app-table>
                    @if (totalPages !== 0) {
                        <app-pagination
                                [pageNumber]="pageNumber"
                                [totalPages]="totalPages"
                                (pageChange)="onPageChange($event)">
                        </app-pagination>
                    }
                }
                @case ("discounts") {
                    <div class="lg:flex justify-center lg:justify-between items-center w-full mx-auto lg:mx-0 lg:flex-row-reverse">
                        <app-primary-button
                                class="pt-5 pb-5"
                                [value]="'Додади нов попуст'"
                                (click)="goToUrl(router, '/shop/product/discount/add')">
                        </app-primary-button>
                        <app-text [value]="'Вкупно попусти: ' + pageInfo.totalElements"></app-text>
                    </div>
                    <app-table
                            [rows]="discounts"
                            [columns]="discountColumns"
                            (rowClicked)="onDiscountRowClick($event)"
                    ></app-table>
                }
                @case ("ambassadors") {
                    <app-text [value]="'Вкупно бренд амбасадори: ' + pageInfo.totalElements"></app-text>
                    <app-table [rows]="customers" [columns]="customerColumns"></app-table>
                }
                @case ("blogs") {
                    <div class="lg:flex justify-center lg:justify-between items-center w-full mx-auto lg:mx-0 lg:flex-row-reverse">
                        <app-primary-button
                                class="pt-5 pb-5"
                                [value]="'Додади нов блог пост'"
                                (click)="goToUrl(router, '/blogs/add')">
                        </app-primary-button>
                        <app-text [value]="'Вкупно блог постови: ' + pageInfo.totalElements"></app-text>
                    </div>
                    <app-table
                            [rows]="blogs"
                            [columns]="blogColumns"
                            (rowClicked)="onBlogRowClick($event)"></app-table>
                }
            }
        } @else {
            <p class="pt-56">unauthorised</p>
        }
    }
</div>

<app-toast [message]="toastMessage"></app-toast>
